(() => {
  const collectionKey = (value) => {
    try {
      const url = new URL(value, window.location.origin);
      const path = url.protocol === 'shopify:' ? `/${url.hostname}${url.pathname}` : url.pathname;
      if (url.protocol !== 'shopify:' && url.origin !== window.location.origin) return null;
      const match = path.match(/\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?collections\/([^/]+)\/?$/i);
      return match ? decodeURIComponent(match[1]).toLowerCase() : null;
    } catch {
      return null;
    }
  };

  const update = () => {
    const seen = new Set();
    const refresh = new Set();
    document.querySelectorAll('[data-home-collection]').forEach((feature) => {
      const key = feature.classList.contains('segastore-hero__button') ? null : collectionKey(feature.dataset.homeCollection);
      const duplicate = Boolean(key && seen.has(key));
      if (key) seen.add(key);
      if (duplicate !== feature.hasAttribute('data-home-duplicate')) {
        feature.toggleAttribute('data-home-duplicate', duplicate);
        feature.hidden = duplicate;
        const tabs = feature.closest('segastore-collection-tabs');
        if (tabs) refresh.add(tabs);
      }
      if (feature.hasAttribute('data-edit-tab')) {
        const panel = document.getElementById(feature.getAttribute('href')?.slice(1));
        if (panel) {
          panel.toggleAttribute('data-home-duplicate', duplicate);
          if (duplicate) panel.hidden = true;
        }
      }
    });

    refresh.forEach((tabs) => tabs.refreshCollections?.());
    document.querySelectorAll('#MainContent > .shopify-section').forEach((section) => {
      const features = Array.from(section.querySelectorAll('[data-home-collection]'));
      section.toggleAttribute('data-home-empty', features.length > 0 && features.every((feature) => feature.hasAttribute('data-home-duplicate')));
    });
    document.querySelectorAll('.segastore-departments__grid').forEach((grid) => {
      const cards = Array.from(grid.querySelectorAll('.segastore-department')).filter((card) => !card.hasAttribute('data-home-duplicate'));
      let position = 0;
      cards.forEach((card, index) => {
        const full = card.classList.contains('segastore-department--feature');
        const next = cards[index + 1];
        const closeRow = position % 2 === 0 && (!next || next.classList.contains('segastore-department--feature'));
        card.dataset.homeSpan = full || closeRow ? '12' : position % 4 === 0 || position % 4 === 3 ? '7' : '5';
        position = full ? 0 : position + 1;
      });
    });
    document.querySelectorAll('.segastore-brands__grid').forEach((grid) => {
      grid.dataset.homeCount = String(Array.from(grid.children).filter((card) => !card.hasAttribute('data-home-duplicate')).length);
    });
  };

  let scheduled = false;
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(() => {
      scheduled = false;
      update();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', update, { once: true });
  else update();
  ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach((event) => document.addEventListener(event, schedule));
  customElements.whenDefined('segastore-collection-tabs').then(schedule);
})();
